// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3IwfE","footer":"ModalFilter_footer__1KzDT"};